import { render, staticRenderFns } from "./ProjectLayout.vue?vue&type=template&id=3e16d0cf&scoped=true&"
import script from "./ProjectLayout.vue?vue&type=script&lang=ts&"
export * from "./ProjectLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectLayout.vue?vue&type=style&index=0&id=3e16d0cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e16d0cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
